(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["canvas-cart-return-language"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.getElementById('canvas-cart-return-language');
    if (!configElement || !document.referrer || window.location.pathname.replace(/\/$/, '') !== '/cart') return;
    try {
      const previous = new URL(document.referrer);
      if (previous.origin !== window.location.origin) return;
      const match = previous.pathname.match(/^\/checkouts\/[^/]+\/[^/]+\/([a-z]{2,3}(?:-[a-z]{2,4}){0,2})(?:\/|$)/i);
      if (!match) return;
      const config = JSON.parse(configElement.textContent);
      const checkoutLocale = match[1].toLowerCase();
      const language = config.languages.find(item => item.code.toLowerCase() === checkoutLocale)
        || config.languages.find(item => item.code.toLowerCase() === checkoutLocale.split('-')[0]);
      if (!language || language.code.toLowerCase() === config.current.toLowerCase()) return;
      const root = new URL(language.root, window.location.origin);
      if (root.origin !== window.location.origin) return;
      const destination = new URL(window.location.href);
      destination.pathname = root.pathname.replace(/\/$/, '') + '/cart';
      if (destination.pathname !== window.location.pathname) window.location.replace(destination.href);
    } catch {}
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-close-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.documentElement;
    if (root.hasAttribute('data-cb-input-mode')) return;
    root.dataset.cbInputMode = 'pointer';
    document.addEventListener('pointerdown', () => {
      root.dataset.cbInputMode = 'pointer';
    }, { capture: true, passive: true });
    document.addEventListener('keydown', (event) => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      if (['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
        root.dataset.cbInputMode = 'keyboard';
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cb-native-search')) {
    class CbNativeSearch extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.input = this.querySelector('.cb-search__input');
        this.results = this.querySelector('.cb-search__results');
        this.status = this.querySelector('[role="status"]');
        this.clearButton = this.querySelector('.cb-search__clear');
        this.shortcuts = this.querySelector('[data-cb-shortcuts]');
        this.featured = this.querySelector('[data-cb-featured]');
        this.cache = new Map();
        this.sequence = 0;
        this.active = -1;
        this.input.setAttribute('role', 'combobox');
        this.input.setAttribute('aria-autocomplete', 'list');
        this.input.setAttribute('aria-haspopup', 'listbox');
        this.input.setAttribute('aria-controls', this.results.id);
        this.input.setAttribute('aria-expanded', 'false');
        this.clearButton.hidden = !this.input.value;
        this.toggleAttribute('data-has-query', !!this.input.value);
        this.input.addEventListener('input', event => { if (!event.isComposing) this.schedule(); });
        this.input.addEventListener('compositionend', () => this.schedule());
        this.input.addEventListener('focus', () => { if (this.input.value.trim().length >= 2) this.schedule(); });
        this.input.addEventListener('keydown', event => this.onKey(event));
        this.clearButton.addEventListener('click', () => {
          this.input.value = '';
          this.clearButton.hidden = true;
          this.removeAttribute('data-has-query');
          this.reset();
          this.input.focus();
        });
        this.querySelector('form').addEventListener('submit', event => {
          if (!this.input.value.trim()) { event.preventDefault(); this.input.focus(); }
        });
        this.addEventListener('focusout', () => queueMicrotask(() => {
          if (!this.contains(document.activeElement)) { this.controller?.abort(); this.sequence++; this.closeResults(); }
        }));
      }
      disconnectedCallback() { this.reset(); }
      reset() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.sequence++;
        this.closeResults();
        if (this.shortcuts) this.shortcuts.hidden = false;
        if (this.featured) this.featured.hidden = false;
        this.status.textContent = '';
        this.status.classList.remove('visually-hidden');
        this.removeAttribute('aria-busy');
      }
      closeResults() {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
        this.active = -1;
      }
      schedule() {
        this.reset();
        this.clearButton.hidden = !this.input.value;
        this.toggleAttribute('data-has-query', !!this.input.value);
        const query = this.input.value.trim();
        if (query.length < 2) return;
        const sequence = this.sequence;
        this.timer = setTimeout(() => this.fetchResults(query, sequence), 220);
      }
      async fetchResults(query, sequence) {
        this.status.textContent = this.dataset.loading;
        this.setAttribute('aria-busy', 'true');
        const url = new URL(this.dataset.endpoint, location.origin);
        url.search = new URLSearchParams({q: query, 'resources[type]':'query,product', 'resources[limit]':'6', 'resources[limit_scope]':'each', section_id:'cb-search-results'}).toString();
        const key = url.href;
        try {
          let markup = this.cache.get(key);
          if (!markup) {
            this.controller = new AbortController();
            const response = await fetch(url, {signal:this.controller.signal, credentials:'same-origin'});
            if (!response.ok) throw new Error('Search unavailable');
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = doc.querySelector('[data-cb-search-response]');
            if (!content) throw new Error('Search response unavailable');
            markup = content.outerHTML;
            if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
            this.cache.set(key, markup);
          }
          if (sequence !== this.sequence || query !== this.input.value.trim()) return;
          this.results.innerHTML = markup;
          if (this.shortcuts) this.shortcuts.hidden = true;
          if (this.featured) this.featured.hidden = true;
          this.results.querySelectorAll('[data-cb-price]').forEach(price => {
            const amount = Number(price.dataset.cbPrice) / 100;
            if (!Number.isFinite(amount)) return;
            try { price.textContent = new Intl.NumberFormat(document.documentElement.lang, {style:'currency', currency:price.dataset.currency}).format(amount); } catch (_) {}
          });
          this.options = [...this.results.querySelectorAll('[role="option"]')];
          this.options.forEach((option, index) => {
            option.id = `${this.results.id}-option-${index}`;
            option.setAttribute('aria-selected', 'false');
            option.tabIndex = -1;
          });
          this.results.hidden = false;
          this.input.setAttribute('aria-expanded', 'true');
          this.status.classList.add('visually-hidden');
          this.status.textContent = this.results.querySelector('[data-cb-search-response]').dataset.status;
        } catch (error) {
          if (error.name !== 'AbortError' && sequence === this.sequence) this.status.textContent = this.dataset.error;
        } finally {
          if (sequence === this.sequence) this.removeAttribute('aria-busy');
        }
      }
      onKey(event) {
        if (event.key === 'Escape') {
          if (!this.results.hidden) { event.preventDefault(); event.stopPropagation(); this.reset(); }
          return;
        }
        if (this.results.hidden || !this.options?.length) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const step = event.key === 'ArrowDown' ? 1 : -1;
          this.active = this.active < 0 ? (step > 0 ? 0 : this.options.length - 1) : (this.active + step + this.options.length) % this.options.length;
          this.options.forEach((option, index) => option.setAttribute('aria-selected', String(index === this.active)));
          const option = this.options[this.active];
          this.input.setAttribute('aria-activedescendant', option.id);
          option.scrollIntoView({block:'nearest'});
        } else if (event.key === 'Enter' && this.active >= 0) {
          event.preventDefault();
          this.options[this.active].click();
        }
      }
    }
    customElements.define('cb-native-search', CbNativeSearch);
    let opener;
    let restoreSearchFocus = true;
    const searchDesktop = window.matchMedia('(min-width:1100px)');
    const searchDialog = document.getElementById('CbSearchDialog');
    if (searchDialog) document.body.append(searchDialog);
    const positionSearchPanel = () => {
      if (!searchDialog?.open || !searchDesktop.matches) return;
      const header = document.querySelector('.header-wrapper');
      const container = header?.querySelector('.container');
      if (!header || !container) return;
      const headerRect = header.getBoundingClientRect();
      const contentRect = container.getBoundingClientRect();
      const top = Math.max(0, headerRect.bottom);
      searchDialog.style.setProperty('--cb-search-top', top + 'px');
      searchDialog.style.setProperty('--cb-search-left', Math.max(0, contentRect.left) + 'px');
      searchDialog.style.setProperty('--cb-search-width', Math.min(contentRect.width, document.documentElement.clientWidth) + 'px');
    };
    let searchLayoutFrame;
    const scheduleSearchLayout = () => {
      if (!searchDialog?.open || searchLayoutFrame) return;
      searchLayoutFrame = requestAnimationFrame(() => {
        searchLayoutFrame = null;
        positionSearchPanel();
      });
    };
    window.addEventListener('resize', scheduleSearchLayout, {passive:true});
    window.addEventListener('scroll', scheduleSearchLayout, {passive:true});
    searchDesktop.addEventListener('change', () => searchDialog?.close());
    const searchHeader = document.querySelector('.header-wrapper');
    if (searchHeader && window.ResizeObserver) new ResizeObserver(scheduleSearchLayout).observe(searchHeader);
    document.addEventListener('focusin', event => {
      if (searchDesktop.matches && searchDialog?.open && !searchDialog.contains(event.target) && !event.target.closest('[data-cb-search-open]')) {
        restoreSearchFocus = false;
        searchDialog.close();
      }
    });
    document.addEventListener('pointerdown', event => {
      event.target.closest('[data-cb-search-open]')?.setAttribute('data-cb-pointer-focus', '');
    }, true);
    document.addEventListener('keydown', event => {
      if (event.key === 'Tab') document.querySelectorAll('[data-cb-pointer-focus]').forEach(button => button.removeAttribute('data-cb-pointer-focus'));
    });
    document.getElementById('CbSearchDialog')?.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !event.defaultPrevented) {
        event.preventDefault();
        event.currentTarget.close();
      }
    });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-cb-search-open]');
      const dialog = document.getElementById('CbSearchDialog');
      if (trigger && dialog && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
        event.preventDefault();
        trigger.toggleAttribute('data-cb-pointer-focus', event.detail > 0);
        opener = trigger;
        if (dialog.open) { dialog.close(); return; }
        restoreSearchFocus = true;
        if (searchDesktop.matches) {
          dialog.show();
          positionSearchPanel();
        } else {
          dialog.showModal();
          document.documentElement.classList.add('cb-search-open');
        }
        document.querySelectorAll('[data-cb-search-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
        dialog.querySelector('.cb-search__input').focus();
      }
      if (event.target.closest('[data-cb-search-close]')) dialog?.close();
      if (!trigger && searchDesktop.matches && dialog?.open && !dialog.contains(event.target)) {
        restoreSearchFocus = false;
        dialog.close();
      }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    document.addEventListener('close', event => {
      if (event.target.id !== 'CbSearchDialog') return;
      document.documentElement.classList.remove('cb-search-open');
      event.target.querySelector('cb-native-search')?.reset();
      document.querySelectorAll('[data-cb-search-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      if (restoreSearchFocus) opener?.focus();
      restoreSearchFocus = true;
    }, true);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cb-search-product"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cb-search-money')) {
    customElements.define('cb-search-money', class extends HTMLElement {
      connectedCallback() {
        const amount = Number(this.dataset.amount) / 100;
        if (!Number.isFinite(amount)) return;
        try { this.textContent = new Intl.NumberFormat(document.documentElement.lang, {style:'currency', currency:this.dataset.currency}).format(amount); } catch (_) {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["market-selector-dialog"] && !Shopify.designMode) return;
  try {
    class CbMarketSelector extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-cb-market-open]');
        if (!trigger) return;
        event.preventDefault();
        event.stopPropagation();
        this.returnFocus = trigger;
        const drawer = trigger.closest('burger-drawer');
        if (drawer) {
          drawer.close();
          this.returnFocus = document.querySelector('a#burger-icon-bubble');
        }
        this.form.reset();
        requestAnimationFrame(() => {
          document.documentElement.classList.add('cb-market-open');
          this.dialog.showModal();
        });
      }, { ...options, capture: true });
      this.querySelector('[data-cb-market-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('cb-market-open');
        this.returnFocus?.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const controls = this.dialog.querySelectorAll('button:not([disabled]), input[type="radio"]:checked');
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, options);
      this.form.addEventListener('submit', () => {
        const selected = this.form.querySelector('input[name="country_code"]:checked');
        const language = this.form.elements.language_code;
        language.value = selected?.dataset.languageCode?.trim() || '';
        language.disabled = !language.value;
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      document.documentElement.classList.remove('cb-market-open');
    }
  }
  if (!customElements.get('cb-market-selector')) customElements.define('cb-market-selector', CbMarketSelector);
  } catch(e) { console.error(e); }
})();

})();
